// @flow
import type { Saga } from 'redux-saga';
import { fork } from 'redux-saga/effects';
import authSaga from './auth/saga';
import tableSaga from './table/saga';
import tableSaga2 from './table2/saga';
import gameSaga from './game/saga';
import profileSaga from './profile/saga';
import rateSaga from './rate/saga';
import paymentSaga from './payment/saga';
import resultsSaga from './results/saga';
import openStatsSaga from './openStats/saga';
import postflopSaga from './postflop/saga';

export default function* root(): Saga<void> {
  yield fork(authSaga);
  yield fork(resultsSaga);
  yield fork(tableSaga);
  yield fork(tableSaga2);
  yield fork(gameSaga);
  yield fork(profileSaga);
  yield fork(rateSaga);
  yield fork(paymentSaga);
  yield fork(openStatsSaga);
  yield fork(postflopSaga);
}
